import { LogOut } from 'iconoir-react';
import React from 'react';

import { NOTIFICATION_TYPES } from '@savgroup-front-common/constants';
import { Banner } from '@savgroup-front-common/core/atoms/Banners';
import { Link } from '@savgroup-front-common/core/atoms/link';
import { SafeFormattedMessageWithoutSpread } from '@savgroup-front-common/core/formatters';
import { ReversioIcon } from '@savgroup-front-common/core/protons/icons';
import { Button } from '@savgroup-front-common/primitive/ui/button';

import { useAppContext } from '../../App.context';

import messages from './messages';

export const NotRegisteredUser: React.FC = () => {
  const { logout } = useAppContext();

  return (
    <div className="flex h-screen flex-col">
      <header className="flex h-12 shrink-0 items-center gap-2 bg-surface-brand-default pr-3 pl-4">
        <ReversioIcon
          color="var(--color-text-contrast-default)"
          className="-translate-y-0.5"
        />

        <div className="ml-auto">
          <Button
            variant="menu"
            size="sm"
            data-testid="oauthCallback_logout"
            onClick={() => logout()}
          >
            <LogOut />
            <SafeFormattedMessageWithoutSpread message={messages.logout} />
          </Button>
        </div>
      </header>

      <div className="flex flex-1 flex-col items-center justify-center gap-4 px-4">
        <Banner notificationType={NOTIFICATION_TYPES.INFO} isOpen>
          <SafeFormattedMessageWithoutSpread
            message={messages.notRegisteredUser}
            values={{
              link: (
                <Link href="https://www.revers.io/" isExternal>
                  <SafeFormattedMessageWithoutSpread
                    message={messages.reversIoLink}
                  />
                </Link>
              ),
            }}
          />
        </Banner>
      </div>
    </div>
  );
};
